<table mat-table [dataSource]="dataSource" class="mat-elevation-z0 table-border" matSort
  (matSortChange)="sortChange($event)">
  <ng-container matColumnDef="channelIcon">
    <th mat-header-cell mat-sort-header *matHeaderCellDef width="80">
      <span> Channel </span>
    </th>
    <td mat-cell *matCellDef="let data" class="additional-table">
      <button mat-icon-button [style.visibility]="!data.expandable ? 'hidden' : ''"
        [style.display]="!data.expandable ? data.level == 0 ? 'none' : '' :''" [style.paddingLeft.px]="data.level * 21"
        (click)="treeControl.toggle(data);data['isExpanded'] = !data['isExpanded']">
        <span *ngIf="data['isExpanded']">
          <i class='fa-solid fa-chevron-down'></i>
        </span>
        <span *ngIf="!data['isExpanded']">
          <i class='fa-solid fa-chevron-right'></i>
        </span>
      </button>

      <span class="additional-account" *ngIf="data?.additionalAccountsData && data?.additionalAccountsData.length > 0">
        <i class="fa-solid fa-user-plus"></i>
      </span><i [title]="data['title']" class="{{data['channelIcon']}}"></i>
    </td>
  </ng-container>

  <ng-container matColumnDef="date">
    <th mat-header-cell mat-sort-header *matHeaderCellDef width="120"> Date </th>
    <td mat-cell [title]="data['date']" *matCellDef="let data" class="truncate"> {{data.date}} </td>
  </ng-container>

  <ng-container matColumnDef="startTime">
    <th mat-header-cell *matHeaderCellDef width="120"> Start/Rcvd Time </th>
    <td mat-cell [title]="data['startTime']" *matCellDef="let data" class="truncate"> {{data.startTime}} </td>
  </ng-container>

  <ng-container matColumnDef="topic">
    <th mat-header-cell mat-sort-header *matHeaderCellDef width="270"> Topic/Title/Subject </th>
    <td mat-cell [title]="data['topic']" *matCellDef="let data" class="truncate" [ngClass]="{ red: displayRed(data)}">
      <i *ngIf="displayRed(data)" class="fa-solid fa-circle-exclamation"></i>
      {{data.topic}}
    </td>
  </ng-container>

  <ng-container matColumnDef="agent">
    <th mat-header-cell mat-sort-header *matHeaderCellDef width="130"> Agent </th>
    <td mat-cell [title]="data['agent']" *matCellDef="let data" class="truncate"> {{data.agent}} </td>
  </ng-container>

  <ng-container matColumnDef="conversationId">
    <th mat-header-cell mat-sort-header *matHeaderCellDef width="100"> Conversation ID </th>
    <td mat-cell [title]="data['conversationId']" *matCellDef="let data" class="truncate"> {{data.conversationId}} </td>
  </ng-container>

  <ng-container matColumnDef="mood">
    <th mat-header-cell mat-sort-header *matHeaderCellDef width="50"> Mood </th>
    <td mat-cell [title]="data['mood']" *matCellDef="let data" class="truncate">
      <span *ngIf="data['mood'] == 'Kudos'"> <i class="fa-solid fa-thumbs-up green" title="kudos"></i> </span>
      <span *ngIf="data['mood'] == 'Dissatisfied'"><i class="fa-solid fa-thumbs-down red " title="Dissatisfied"> </i>
      </span>
    </td>
  </ng-container>



  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

  <tr class="mat-row" *matNoDataRow>
    <td class="mat-cell" [attr.colspan]="displayedColumns.length" *ngIf="noRecord()">
      <div class="center no-result">
        <p>{{noRecordFoundMsg}}</p>
      </div>

    </td>
  </tr>
  <!-- CCR1-3138 -->
  <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="onRowSingleClick(row)"
    (keydown.enter)="onTableRowEnter(row)" (focus)="selectedRow = row" [ngClass]="{ selected: isRowSelected(row) }"
    tabindex="0">
  </tr>
</table>
<div class="footer-controls">
  <div class="footer-controls-left"></div>
  <div class="footer-controls-right" *ngIf="displayPagination()">

    <div class="custom-pagination ">
      <button class="arrow-btn" mat-stroked-button title="Start Page" disabled="{{ pager.currentPage === 1 }}"
        (click)="setPage(1)">
        <i class="fa-solid fa-chevrons-left"></i>
      </button>

      <button class="arrow-btn" mat-stroked-button title="Previous" disabled="{{ pager.currentPage === 1 }}"      
        (click)="setPage(pager.currentPage - 1)">
        <i class="fa-solid fa-chevron-left"></i>
      </button>

      <span *ngFor="let num of pager.pages;">
        <button class="number" title="{{num}}" [ngClass]="pager.currentPage   == num ? 'selected' :'' "
          (click)="setPage(num)" mat-stroked-button>{{num}}</button>
      </span>



      <button class="arrow-btn" mat-stroked-button title="Next" disabled="{{ pager.currentPage === pager.totalPages }}"
              (click)="setPage(pager.currentPage + 1)">
        <i class="fa-solid fa-chevron-right"></i>
      </button>

      <button class="arrow-btn" mat-stroked-button title="Last Page"
        disabled="{{ pager.currentPage === pager.totalPages }}" (click)="setPage(pager.totalPages)">
        <i class="fa-solid fa-chevrons-right"></i>
      </button>
    </div>
  </div>
</div>


<!-- Copyright 2018 Google Inc. All Rights Reserved.
      Use of this source code is governed by an MIT-style license that
      can be found in the LICENSE file at http://angular.io/license -->